import React from 'react'

export const louisianaSetupVars = {
  siteId: 'la',
  pathPrefix: '/la',
  topScreenshotUrl: '/images/iowa/marketing/Images/Mockup@2x.png',
  menuHeader: "Discover Louisiana's Solution for:",
  appUrl: 'https://la.headed2.com',
  logoImg: '/images/assets/louisiana/horizontal/dark.svg',
  headerTitle: `The Louisiana CareerExplorer`,
  headerTitleDescription: (
    <div>
      <p>
        The Louisiana CareerExplorer is a state-supported career exploration and planning
        system designed to support career and college readiness, district strategy, and
        transition planning.
      </p>
      <h4>
        With a <b>FREE</b> Headed2 account, you will have access to:
      </h4>
      <ul className="top-features">
        <li className="onetprofile">Occupation & College Info</li>
        <li className="financial-literacy">Financial Literacy Tools</li>
        <li className="onetassess">Self Assessments</li>
        <li className="plantool">Planning Tools</li>
      </ul>
    </div>
  ),
  sponsorMsg: (
    <span>
      The Louisiana CareerExplorer is a state-approved Career Information and
      Decision-making System designed to support the development of students’ Individual
      Career and Academic Plan (ICAP).
    </span>
  ),
  sponsorImg: '/images/nolaba/nolaba_logo_color.svg',
  brochureDownloadImg: '/images/www/new/homepage/Homepage-Download-CCZ@2x.png',
  brochureDownloadUrl: `https://drive.google.com/uc?export=download&id=1Dhm_gXb3EvaXuCccsofmOt05DRtSmOdU`,
  otherSites: [
    {
      url: 'https://www.pacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/PA-logo.svg'
    },
    {
      url: 'https://ar.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/AR-Logo.svg'
    },
    {
      url: 'https://nv.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/NV-logo.svg'
    },
    {
      url: 'https://va.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/VA-logo.svg'
    }
  ]
}
